<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <v-form ref="labelForm">
        <v-layout column justify-center class="pa-3">
          <v-layout>
            <v-flex xs6>
              <v-select
                label="标签类型" prepend-icon="$vuetify.icons.location"
                disabled
                :items="form.labelTypeSelect" item-text="label" item-value="value" v-model="form.labelType" chips></v-select>
            </v-flex>
            <v-flex xs6>
              <l-autocomplete
                v-if="!disabledFlag"
                :disabled="disabledFlag"
                label="所属标签类型"
                :get-data="findLabelClass"
                item-text="name"
                prepend-icon="$vuetify.icons.location"
                v-model="form.typeList"
                chips
                multiple
              ></l-autocomplete>
              <v-select v-else :items="form.typeList" item-text="name" item-value="id" prepend-icon="$vuetify.icons.location" label="标前所属类型" chips disabled multiple
              v-model="form.typeList"></v-select>
            </v-flex>
          </v-layout>
          <v-form ref="sysLabelForm" v-if="form.labelType==='sys'">
            <v-layout column>
              <v-layout>
                <v-flex xs6>
                  <v-text-field v-model="form.name" label="标签名称" prepend-icon="$vuetify.icons.title" :disabled="disabledFlag" :rules="[$rules.requiredS()]"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field label="标签值" prepend-icon="$vuetify.icons.code" v-model="form.value" :disabled="disabledFlag" :rules="[$rules.requiredS()]"></v-text-field>
                </v-flex>
              </v-layout>
              <v-flex xs12>
                <v-textarea rows="1" auto-grow v-model="form.description" label="标签描述" prepend-icon="$vuetify.icons.comment" :disabled="disabledFlag"></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
          <v-form ref="bizLabelForm" v-if="form.labelType==='biz'">
            <v-layout column>
              <v-layout>
                <v-flex xs3>
                  <v-text-field v-model="form.name" label="标签名称" prepend-icon="$vuetify.icons.title" :disabled="disabledFlag" :rules="[$rules.requiredS()]"></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="所有业务系统名" prepend-icon="$vuetify.icons.code" v-model="form.systemId" :disabled="disabledFlag" :rules="[$rules.requiredS()]"></v-text-field>
                </v-flex>
                <v-flex xs5>
                  <v-text-field label="回调地址" prepend-icon="$vuetify.icons.code" v-model="form.callBackURL" :disabled="disabledFlag" :rules="[$rules.requiredS()]">
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-radio-group mandatory row v-model="form.isNecessary" label="是否必填" prepend-icon="$vuetify.icons.lock" :disabled="disabledFlag">
                <v-radio :value="'0'" label="非必填"></v-radio>
                <v-radio :value="'1'" label="必填"></v-radio>
              </v-radio-group>
              <v-flex xs12>
                <v-textarea rows="1" auto-grow v-model="form.description" label="标签描述" prepend-icon="$vuetify.icons.comment" :disabled="disabledFlag"></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
        </v-layout>
      </v-form>
      <v-layout justify-center v-if="!disabledFlag">
        <v-btn class="primary" :loading="loading" :disabled="disabledFlag" @click="(form.labelType==='sys')?sysSubmit():bizSubmit()">提交</v-btn>
      </v-layout>
      <v-layout justify-center v-else>
        <v-btn class="primary" @click="disabledFlag=!disabledFlag">修改</v-btn>
      </v-layout>
    </v-card>
  </l-layout>
</template>

<script>
export default {
  name: 'labelDetail',
  props: {
    formData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    labelTypeProp: {
      type: String,
      default: 'sys'
    }
  },
  data () {
    return {
      loading: false,
      disabledFlag: true,
      form: {
        callBackURL: '',
        name: '',
        description: '',
        typeList: [],
        value: '',
        isNecessary: '0',
        systemId: '',
        labelTypeSelect: [
          {value: 'sys', label: '系统标签'},
          {value: 'biz', label: '自定义标签'}
        ],
        sysTypeList: [],
        bizTypeList: [],
        labelType: '',
      }
    }
  },
  created () {
    console.log(this.formData)
    this.init()
  },
  methods: {
    init () {
      this.form.labelType = this.labelTypeProp
      this.form.name = this.formData.name
      this.form.description = this.formData.description
      if (this.form.labelType === 'sys') {
        this.initSysForm()
      }
      else {
        this.initBizForm()
      }
    },
    initSysForm () {
      this.form.value = this.formData.value
      for (let i = 0; i < this.formData.sysTypes.length; i++) {
        this.form.typeList.push(this.formData.sysTypes[i].msgLabelType)
      }
    },
    initBizForm () {
      this.form.isNecessary = this.formData.necessary + ''
      this.form.systemId = this.formData.institutionId
      this.form.callBackURL = this.formData.callBackURL
      for (let i = 0; i < this.formData.bizTypes.length; i++) {
        this.form.typeList.push(this.formData.bizTypes[i].msgLabelType)
      }
    },
    getUserInfo () {
      return JSON.parse(sessionStorage.getItem('loginInfo'))
    },
    async findLabelClass (searchValue) {
      try {
        let url = '/messageApi/admin/getMsgLabelType'
        let {items, amount} = await this.$store.dispatch('message/getList', {pagination: {pages: 1, rowsPerPage: 10}, search: {key: 'name', value: searchValue}, url: url})
        return items
      }
      catch (e) {
        this.$L.alert('error', e.message)
        return []
      }
    },
    async sysSubmit () {
      if (this.$refs.sysLabelForm.validate()) {
        this.loading = true
        try {
          let typeList = []
          for (let i = 0; i < this.form.typeList.length; i++) {
            typeList.push(this.form.typeList[i].id)
          }
          let params = {'msgLabelSys': {'name': this.form.name,
            'id': this.formData.id,
            'creator': this.getUserInfo().name,
            'description': this.form.description,
            'value': this.form.value},
          'typeList': typeList}
          let url = '/messageApi/admin/addMsgLabelSys'
          let res = await this.$store.dispatch('message/addActions', {params: params, url: url})
          if (res.data.code + '' === '200') {
            this.$L.alert('success', {message: '更新成功'})
            this.$store.commit('message/setLabelRefresh', true)
            this.disabledFlag = true
          }
          else {
            this.$L.alert('error', {message: '更新失败，原因:' + res.data.msg})
          }
        }
        catch (e) {
          console.log(e)
        }
        finally {
          this.loading = false
        }
      }
      else {
        this.$L.alert('error', {message: '表单数据不合法'})
      }
    },
    async bizSubmit () {
      if (this.$refs.bizLabelForm.validate()) {
        this.loading = true
        try {
          let typeList = []
          for (let i = 0; i < this.form.typeList.length; i++) {
            typeList.push(this.form.typeList[i].id)
          }
          let params = {'msgLabelBiz': {'name': this.form.name,
            'id': this.formData.id,
            'callBackURL': this.form.callBackURL,
            'description': this.form.description,
            'institutionId': this.form.systemId,
            'necessary': this.form.isNecessary},
          'typeList':
              typeList}
          let url = '/messageApi/admin/addMsgLabelBiz'
          let res = await this.$store.dispatch('message/addActions', {params: params, url: url})
          if (res.data.code + '' === '200') {
            this.$L.alert('success', {message: '更新成功'})
            this.disabledFlag = true
            this.$store.commit('message/setLabelRefresh', true)
          }
          else {
            this.$L.alert('error', {message: '更新失败，原因:' + res.data.msg})
          }
        }
        catch (e) {
          console.log(e)
        }
        finally {
          this.loading = false
        }
      }
      else {
        this.$L.alert('error', {message: '表单数据不合法'})
      }
    }
  }
}
</script>

<style scoped>

</style>
